export default {
  get: (state) => () => {
    return state || {}
  }
}
